const recordRoutes = [
  {
    path: "/shortMessage",
    name: "shortMessage",
    component: () => import("@/views/operation/shortMessage.vue"),
    meta: {
      title: "短信记录",
      keepAlive: true,
    },
  },
];

export default recordRoutes;
